import { ResponseContext } from "../../../@api";

import { translationKeys } from "../../models/app-translation-keys";
import { IMiddelware } from "../../models/interfaces/middelware.interface";
import { GlobalErrorsStore } from "../../stores";

export class AuthorizationHandlingMiddleware implements IMiddelware {
  public readonly handledHttpStatusCodes = [401, 403];

  constructor(private readonly globalErrorsStore: GlobalErrorsStore) {}

  public async post(context: ResponseContext): Promise<void> {
    if (this.handledHttpStatusCodes.includes(context.response.status)) {
      this.setError();
    } else {
      this.resetError();
    }
  }

  public resetError() {
    this.globalErrorsStore.removeError(translationKeys.globalErrors.authorization);
  }

  public setError() {
    this.globalErrorsStore.addErrorIfNotExists(translationKeys.globalErrors.authorization);
  }
}
